import { StoreContext } from '../../../lib/store';
import * as React from 'react';
import { CSSProperties, useContext } from 'react';
import { DisplayConfigType } from '../../../lib/config';
import classNames from 'classnames';
import style from './styles.scss';
import OptOutIcon from 'common/components/opt-out/icon';
import { btnPositionStyle } from 'common/js/configs/utils';

export function Component() {
  const store = useContext(StoreContext);
  const { optoutBtn, expandBtn } = store.formatConfig as DisplayConfigType;
  const { childPrivacyApplied } = store.adContext;

  let positionStyle: CSSProperties = {};

  if (optoutBtn.position.toLowerCase().indexOf('bottom') !== -1) {
    positionStyle.bottom = 0;
    positionStyle.top = 'auto';
  }
  if (optoutBtn.position.toLowerCase().indexOf('right') !== -1) {
    positionStyle.right = 0;
    positionStyle.left = 'auto';
  }

  if (expandBtn?.position) {
    positionStyle = {
      ...positionStyle,
      ...btnPositionStyle(expandBtn.position === 'left' ? 'right' : 'left')
    };
  }

  return (
    <div
      className={classNames(style.optoutStyle, {
        [style.optoutFontSize]: !childPrivacyApplied
      })}
      style={positionStyle}
    >
      <OptOutIcon
        iconSize={optoutBtn.iconSize}
        iconPadding={optoutBtn.paddingSize}
        onClick={e => store.userOptoutHandler.handle(e)}
        useContainerStyle={false}
        iconColor={optoutBtn.iconColor}
        childPrivacyApplied={childPrivacyApplied}
      />
    </div>
  );
}
